// Mobile QA route for the paint systems viewer.
import ProjectTechnicalDetailsPaintSystemsMobileIndex from "./index";

export default [
  { path: "/project/qa/paint_systems", component: ProjectTechnicalDetailsPaintSystemsMobileIndex, name: "Paint Systems" },
];
